import { useNavigate } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';

import { Strings } from '@app/constants';
import { AuthLayout } from '@app/layouts';
import { SignUpForm } from './sign-up-form';

// ------------------------------------------------

const SignUpPage = () => {
  const navigate = useNavigate();
  return (
    <AuthLayout title={Strings.header.login}>
      <Stack spacing={2}>
        <Typography variant="h3">
          {Strings.auth.signUp}
          <Typography color="text.secondary">{Strings.auth.signUpYour}</Typography>
        </Typography>

        <SignUpForm />
      </Stack>
    </AuthLayout>
  );
};

export { SignUpPage };
